



















































































import Vue, { PropType } from "vue";
import HttpClientFactory from "../../../services/HttpClientFactory";
import HttpClient from "../../../services/HttpClient";
import Invoice from "../../../types/invoices/Invoice";
import ApiInvoice from "../../../types/invoices/api/ApiInvoice";
import { TabPane, Tabs } from "../../../components";
import EditInvoicesDataForm from "./pills/EditInvoicesDataForm.vue";
import EditInvoicesLines from "./pills/EditInvoicesLines.vue";
import EditInvoicesFormFinal from "./pills/EditInvoicesFormFinal.vue";
import ApiInvoiceLine from "../../../types/invoices/api/ApiInvoiceLine";
import InvoiceLine from "../../../types/invoices/InvoiceLine";
import currency from "currency.js";
import ApiInvoiceRequest from "../../../types/invoices/api/ApiInvoiceRequest";
import { snakeCase } from "lodash";
import Receiver from "../../../types/receivers/Receiver";
import moment from "moment";
import BaseAlert from "../../../components/black_dashboard_pro/BaseAlert.vue";

export default Vue.extend({
  name: "edit-invoices-page",
  props: {
    invoiceId: {
      required: true,
      type: String as PropType<string>,
    },
  },
  components: {
    // @ts-ignore
    BaseAlert,
    TabPane,
    //@ts-ignore
    Tabs,
    EditInvoicesDataForm,
    EditInvoicesLines,
    EditInvoicesFormFinal,
  },
  computed: {
    getInvoiceId(): string | null {
      return this.invoiceId;
    },
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      invoice: {
        receiver: {} as Receiver,
        invoiceDateAt: null,
        invoiceNumber: "",
        dueDateAt: null,
        description: "",
        status: "",
        priceWithoutVatAndTaxes: currency(0),
        vat: currency(0),
        grandTotal: currency(0),
        lines: [] as InvoiceLine[],
      } as Invoice,
    };
  },
  async created() {
    this.httpClient = HttpClientFactory.getInstance();
    await this.loadInvoice();
  },
  methods: {
    async loadInvoice() {
      try {
        const response = await this.httpClient.get(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            `/invoice/v1/${this.invoiceId}/view`
        );

        const invoiceData: ApiInvoice = response.data;
        if (invoiceData === undefined) {
          return;
        }
        this.invoice.receiver = invoiceData.receiver;
        this.invoice.invoiceDateAt = new Date(invoiceData.invoiceDateAt);
        this.invoice.invoiceNumber = invoiceData.invoiceNumber;
        this.invoice.dueDateAt = new Date(invoiceData.dueDateAt);
        this.invoice.description = invoiceData.description;
        this.invoice.status = invoiceData.status;
        this.invoice.priceWithoutVatAndTaxes = currency(
          invoiceData.priceWithoutVatAndTaxes,
          { fromCents: true, precision: 2 }
        );
        this.invoice.vat = currency(invoiceData.vat, {
          fromCents: true,
          precision: 2,
        });
        this.invoice.grandTotal = currency(invoiceData.grandTotal, {
          fromCents: true,
          precision: 2,
        });
        this.invoice.lines = invoiceData.invoiceLines.map(
          (line: ApiInvoiceLine) => {
            return {
              description: line.description,
              qty: line.qty,
              unit: line.unit,
              price: currency(line.price, { fromCents: true, precision: 2 }),
              vat: line.vat,
              totalVat: currency(line.totalVat, {
                fromCents: true,
                precision: 2,
              }),
            };
          }
        );
      } catch (e) {
        const error: any = {
          text: this.$t("invoices:error"),
          type: "error",
        };
        this.$notify(error);
      }
    },
    updateInvoice() {
      const transformedData: ApiInvoiceRequest = {
        receiverId: this.invoice.receiver.id,
        invoiceDateAt: moment(this.invoice.invoiceDateAt).format("YYYY-MM-DD"),
        invoiceNumber: this.invoice.invoiceNumber,
        dueDateAt: moment(this.invoice.dueDateAt).format("YYYY-MM-DD"),
        description: this.invoice.description,
        priceWithoutVatAndTaxes: this.invoice.priceWithoutVatAndTaxes.intValue,
        vat: this.invoice.vat.intValue,
        grandTotal: this.invoice.grandTotal.intValue,
        lines: this.invoice.lines.map((line: InvoiceLine) => ({
          description: line.description,
          qty: line.qty,
          unit: line.unit,
          price: line.price.intValue,
          vat: line.vat,
          totalVat: line.totalVat.intValue,
        })),
      };
      this.httpClient
        .put(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            `/invoice/v1/${this.invoiceId}`,
          transformedData
        )
        .then(() => {
          const succes: any = {
            text: this.$t("invoices:saved"),
            type: "success",
          };
          this.$notify(succes);
          this.$emit("on-update-lines", this.invoice);
        })
        .catch((e: any) => {
          const arrayOfErrors: any[] = e.response.data.errors;
          arrayOfErrors.forEach((error: any) => {
            this.showValidationError(
              snakeCase(error.field),
              snakeCase(error.rule)
            );
          });
        });
    },
    showValidationError(field: string, rule: string) {
      const error: any = {
        text: this.$t("invoices:validate." + field + "." + rule),
        type: "error",
      };
      this.$notify(error);
    },
    onLinesUpdated(lines: InvoiceLine[]) {
      this.invoice.lines = lines;
      this.getVatTotal();
      this.getGrandTotal();
      this.updateInvoice();
    },
    onLineDeleted(lines: InvoiceLine[]) {
      this.invoice.lines = lines;
      this.getVatTotal();
      this.getGrandTotal();
    },
    getVatTotal() {
      const invoiceLines = this.invoice.lines;
      for (const invoiceLine of invoiceLines) {
        const subtotal = currency(invoiceLine.qty).multiply(invoiceLine.price);
        invoiceLine.totalVat = subtotal.multiply(invoiceLine.vat).divide(100);
      }
      const totalVat = invoiceLines.reduce(
        (accumulator: currency, current: InvoiceLine) => {
          return current.totalVat.add(accumulator);
        },
        currency(0)
      );
      this.invoice.vat = totalVat;
    },
    getGrandTotal() {
      const array = this.invoice.lines;
      const total = array.reduce(
        (accumulator: currency, current: InvoiceLine) => {
          return current.price.multiply(current.qty).add(accumulator);
        },
        currency(0)
      );
      this.invoice.priceWithoutVatAndTaxes = total;
      const grandTotal = this.invoice.priceWithoutVatAndTaxes.add(
        this.invoice.vat
      );
      this.invoice.grandTotal = grandTotal;
    },
    onInvoice(invoice: Invoice) {
      this.invoice = invoice;
    },
  },
});
